module.exports = __webpack_public_path__ + "61a7e8114e52a83c30b0e273584bfe7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/LiveChat.svg
// module id = 333
// module chunks = 0